import React from 'react'

const styles = {
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6
  },
  label: {
    fontSize: 13,
    fontWeight: 600,
    color: '#1c2419',
    minWidth: 140
  },
  select: {
    background: '#f6f1e3',
    border: '1px solid #cec3a5',
    borderRadius: 999,
    padding: '4px 28px 4px 10px',
    fontSize: 12.5,
    fontWeight: 500,
    color: '#1c2419',
    cursor: 'pointer',
    outline: 'none',
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    backgroundImage: 'none',
    position: 'relative'
  }
}

const PillSelect = ({ options = [], value, onChange, label }) => {
  const [hover, setHover] = React.useState(false)
  const [focused, setFocused] = React.useState(false)

  const selectStyle = {
    ...styles.select,
    ...(hover && !focused ? { background: '#fbf8f1', borderColor: '#b8aa86' } : {}),
    ...(focused ? { background: '#e3eee0', borderColor: '#1f5e3a', color: '#1f5e3a' } : {})
  }

  return (
    <div style={styles.container}>
      {label && <span style={styles.label}>{label}</span>}
      <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
        <select
          style={selectStyle}
          value={value ?? ''}
          onChange={(e) => onChange && onChange(e.target.value)}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
        >
          {options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
        <span
          style={{
            position: 'absolute',
            right: 10,
            top: '50%',
            transform: 'translateY(-50%)',
            pointerEvents: 'none',
            fontSize: 11,
            color: focused ? '#1f5e3a' : '#1c2419',
            lineHeight: 1
          }}
        >
          &#9662;
        </span>
      </span>
    </div>
  )
}

export default PillSelect
